(function () {
  const Core = window.RB.Core;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Void Gate": {
      bonusDamage: function (state, src, item, t) {
        const o = state.objs[t];
        return o && o.loc && o.loc.t === "bf" && o.loc.iid === src ? 1 : 0;
      },
    },

    "Fortified Position": {
      triggers: [{
        on: "combatStart", selfBf: true,
        condSpec: { k: "showdownHereDefending" },
        label: "a unit gains Shield 2",
        targets: [{ bind: "t", spec: { type: "unit" }, prompt: "Give which unit Shield 2 this combat?" }],
        program: [{ op: "grant", to: "$t", keyword: "shield", kwValue: 2, dur: "combat" }],
      }],
    },

    "Startipped Peak": {
      triggers: [{
        on: "hold", selfBf: true, you: true, optional: true,
        label: "channel 1 rune exhausted?",
        program: [{ op: "channel", n: 1, exhausted: true }],
      }],
    },

    "Trifarian War Camp": {
      auraMightSpecs: [{ n: 1, who: "all", scope: "atSource" }],
    },

    "Zaun Warrens": {
      triggers: [{
        on: "conquer", selfBf: true, you: true, label: "discard 1, draw 1",
        program: [
          { op: "discard", n: 1 },
          { op: "draw", n: 1 },
        ],
      }],
    },

    "Monastery of Hirana": {
      triggers: [{
        on: "conquer", selfBf: true, you: true, label: "meditation",
        program: [{
          op: "may", prompt: "Spend a buff to draw 1?", then: [
            { op: "choose", bind: "b", spec: { type: "unit", friendly: true, hasBuff: true }, prompt: "Spend whose buff?" },
            {
              op: "if", cond: { k: "targetsChosen", bind: "b" }, then: [
                { op: "removeBuff", to: "$b" },
                { op: "draw", n: 1 },
              ],
            },
          ],
        }],
      }],
    },

    "Sigil of the Storm": {
      triggers: [{
        on: "conquer", selfBf: true, you: true, label: "storm surge",
        program: [
          { op: "choose", bind: "r", spec: { type: "rune", friendly: true }, prompt: "Recycle which rune?" },
          { op: "recycleTargets", to: "$r" },
        ],
      }],
    },

    "Targon's Peak": {
      triggers: [{
        on: "conquer", selfBf: true, you: true, label: "celestial blessing",
        program: [{
          op: "delayed", on: "endOfTurn", label: "Targon's Peak: ready 2 runes",
          program: [
            { op: "choose", bind: "r", spec: { type: "rune", friendly: true, ready: false }, min: 0, max: 2, prompt: "Ready up to 2 runes" },
            { op: "ready", to: "$r" },
          ],
        }],
      }],
    },

    "The Grand Plaza": {
      triggers: [{
        on: "hold", selfBf: true, you: true, label: "grand triumph",
        program: [{
          op: "if", cond: { k: "unitsHereAtLeast", n: 7 }, then: [{ op: "winGame", how: "The Grand Plaza" }],
        }],
      }],
    },

    "Back-Alley Bar": {
      triggers: [{
        on: "move", label: "one for the road",
        condSpec: { k: "evFromSelfBf" },
        controllerFromEvent: true,
        program: [{ op: "grant", to: "$ev", might: 1 }],
      }],
    },

    "Obelisk of Power": {
      triggers: [{
        on: "beginningPhase", controllerFromEvent: true, label: "empowerment",
        condSpec: { k: "turnMax", n: 2 },
        program: [{ op: "channel", n: 1 }],
      }],
    },

    "The Arena's Greatest": {
      triggers: [{
        on: "beginningPhase", controllerFromEvent: true, label: "opening ovation",
        condSpec: { k: "turnMax", n: 2 },
        program: [{ op: "points", n: 1 }],
      }],
    },

    "Vilemaw's Lair": { noRetreat: true },

    "Windswept Hillock": {
      auraKwSpecs: [{ name: "ganking", value: null, who: "all", scope: "atSource" }],
    },

    "Aspirant's Climb": { victoryDelta: 1 },

    "Reaver's Row": {
      triggers: [{
        on: "combatStart", selfBf: true, label: "escape route",
        condSpec: { k: "showdownDefender" },
        program: [{
          op: "may", prompt: "Move a friendly unit here to base?", then: [
            { op: "choose", bind: "t", spec: { type: "unit", friendly: true, here: true }, prompt: "Move which unit to base?" },
            { op: "move", to: "$t", dest: "base" },
          ],
        }],
      }],
    },

    "Hallowed Tomb": {
      triggers: [{
        on: "hold", selfBf: true, you: true, optional: true, label: "return your Chosen Champion",
        condSpec: { k: "evPlayerChampionInTrash" },
        targets: [{
          bind: "t",
          spec: { zone: "trash", chosenChampion: true },
          prompt: "Return your Chosen Champion to your Champion Zone?",
        }],
        program: [{ op: "toChampionZone", to: "$t" }],
      }],
    },

    "Reckoner's Arena": {
      triggers: [{
        on: "hold", selfBf: true, you: true, label: "activate conquer effects here",
        program: [{ op: "reEmit", event: "unitConquer" }],
      }],
    },

    "The Candlelit Sanctum": {
      triggers: [{
        on: "conquer", selfBf: true, you: true, label: "look at the top two",
        program: [{
          op: "lookRecycleOrder", n: 2,
          prompt: "Recycle one or both of them (choose none to keep them)",
          orderPrompt: "Which one goes back on top?",
        }],
      }],
    },

    "The Dreaming Tree": {
      triggers: [{
        on: "targeted", oncePerTurn: true, controllerFromEvent: true, label: "draw 1",
        condSpec: { k: "evTargetsUnitHereByActor" },
        program: [{ op: "draw", n: 1 }],
      }],
    },

    "Altar to Unity": {
      triggers: [
        {
          on: "hold",
          selfBf: true,
          you: true,
          label: "when you hold here",
          targets: [],
          program: [{ op: "token", name: "Recruit", n: 1, loc: "base", exhausted: false }],
        },
      ],
    },

    "Bandle Tree": { extraHideSlot: true },

    "Grove of the God-Willow": {
      triggers: [
        {
          on: "hold",
          selfBf: true,
          you: true,
          label: "when you hold here",
          targets: [],
          program: [{ op: "draw", n: 1 }],
        },
      ],
    },

    "Navori Fighting Pit": {
      triggers: [
        {
          on: "hold",
          selfBf: true,
          you: true,
          label: "when you hold here",
          targets: [{ bind: "t1", spec: { type: "unit", here: true }, prompt: "Buff..." }],
          program: [{ op: "buff", to: "$t1" }],
        },
      ],
    },

    "Recruit (DE)": {},

    "Recruit (NX)": {},

    "Recruit (ZN)": {},

    "Sprite": {},
  });
})();
